import type { ReactElement } from 'react';

export enum Variant {
  DYNAMIC = 'dynamic',
  EXPANSIBLE = 'expansible',
  FIXED = 'fixed',
}

export enum BorderRadiusSize {
  NONE = 'none',
  SMALL = 'small',
  MEDIUM = 'medium',
  BIG = 'big',
}

export enum Status {
  ERROR = 'error',
  SUCCESS = 'success',
}

export enum AvatarType {
  GROUP = 'group',
  TEAM = 'team',
  TEAM_MEMBER = 'teamMember',
}

export interface Avatar {
  color?: string;
  name?: string;
  src?: string;
  type: AvatarType;
}

export interface Chip {
  avatar?: Avatar;
  id: string;
  label: string;
  status: Status;
}

export type SuggestionProps = {
  avatarUrl?: string;
  avatarColor?: string;
  children?: ReactElement;
  description?: string;
  isLocked?: boolean;
  name?: string;
  onClick: (value: string) => void;
  value: string;
};
